import { Box, Button, Dialog } from '@mui/material';
import { useMutation } from '@apollo/client';
import { errorToast, successToast } from '../../../common/utils/alert';
import { errorMessages } from '../../../common/utils/constants';
import { DELETE_PROJECT_MEMBER } from '../../gql';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../redux/hooks';

interface IDeleteProjectMemberProps {
  onCancel: () => void;
  onClose: () => void;
  isVisible: boolean;
  memberId: string;
  updateProjectMemberCallback: () => Promise<void>;
}

const DeleteProjectMemberModal = ({
  onCancel,
  onClose,
  memberId,
  isVisible,
  updateProjectMemberCallback
}: IDeleteProjectMemberProps): JSX.Element => {
  const [actionUserId, setActionUserId] = useState<string>('');
  const { profileData } = useAppSelector((state) => state.profileData);

  const [deleteProjectMemberMutation, { loading }] = useMutation(
    DELETE_PROJECT_MEMBER
  );

  useEffect(() => {
    if (profileData) {
      if (profileData.memberId) {
        setActionUserId(profileData.memberId);
      }
    }
  }, [profileData]);

  const handleDelete = (): void => {
    onClose();
    deleteProjectMemberMutation({
      variables: { actionUserId, id: memberId }
    })
      .then(async () => {
        successToast('Project Member Deleted Successfully');
        await updateProjectMemberCallback();
      })
      .catch(() => {
        errorToast(errorMessages.ErrorMessageDeleteUserFromProject);
      });
  };

  return (
    <Dialog
      sx={{
        '.MuiPaper-root': {
          boxShadow: 'none',
          backgroundColor: 'transparent'
        }
      }}
      open={isVisible}
    >
      <Box
        sx={{
          borderRadius: '28px',
          background:
            'linear-gradient(0deg, rgba(41, 93, 171, 0.11), rgba(41, 93, 171, 0.11)), #FDFBFF'
        }}
      >
        <Box
          sx={{
            fontFamily: 'Be Vietnam Pro',
            fontWeight: 500,
            fontSize: '24px',
            color: '#1A1B1F',
            textAlign: 'center',
            padding: '36px 80px'
          }}
        >
          Are you sure you want to remove this member from the project?
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '24px'
          }}
        >
          <Button
            sx={{
              padding: '10px 12px 10px 12px',
              fontSize: '18px',
              fontWeight: 500,
              color: '#295DAB',
              textTransform: 'none'
            }}
            onClick={onCancel}
            data-testid="cancel-button"
          >
            Cancel
          </Button>
          <Button
            sx={{
              padding: '10px 12px 10px 12px',
              fontSize: '18px',
              fontWeight: 500,
              color: '#295DAB',
              textTransform: 'none'
            }}
            onClick={handleDelete}
            disabled={loading}
            data-testid="yes-delete-button"
          >
            Yes, Remove
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default DeleteProjectMemberModal;
